module.exports = __webpack_public_path__ + "img/logo-paninti-affiliate.2a43128.svg";